import React from 'react';
import { useOutletContext } from 'react-router-dom';
import TeacherAvailabilityManagement from '../admin/TeacherAvailabilityManagement';

const TeacherAvailability = () => {
  const { profile } = useOutletContext();
  return <TeacherAvailabilityManagement teacherIdOverride={profile.id} />;
};

export default TeacherAvailability;
